import { observable, makeObservable, action } from 'mobx'

import SharedStore from 'shared/stores/shared.store'

import {
  createAccountsApi,
  AccountsApi,
  AccountResponse,
  ActiveProfileType,
  LinkLegalEntityParams,
} from '../api/accounts.api'

export class AccountStore extends SharedStore<AccountsApi> {
  storeName = 'AccountsStore'
  declare childApi: AccountsApi

  @observable account: AccountResponse | null = null

  constructor(root) {
    super()
    this.childApi = createAccountsApi(root.apiClient)

    makeObservable(this)
  }

  @action updateAccount = (account: AccountResponse) => {
    this.account = {
      ...(this.account ?? {}),
      ...account,
    } as AccountResponse
  }

  fetchAccount = async (accountType: ActiveProfileType) => {
    this.toggleLoading(true)

    const response = await this.childApi.fetchAccount(accountType)

    if (response.responseType === 'success') {
      this.updateAccount(response.data)
    }

    this.toggleLoading(false)

    return response
  }

  linkLegalEntity = async (accountType: ActiveProfileType, data: LinkLegalEntityParams) => {
    this.toggleLoading(true)

    const response = await this.childApi.linkLegalEntity(accountType, data)

    if (response.responseType === 'success') {
      this.updateAccount(response.data)
    }

    this.toggleLoading(false)

    return response
  }
}
